exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".long-modal {\r\n  height: calc(100vh - 200px);\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.long-modal::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./static/sass/resource-modal.scss
// module id = 339
// module chunks = 3